import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form-html5-validation';
import {
    isRequiredText,
    isRequiredDate,
    isRequiredStateSelection,
    isRequiredSelection,
    isRequiredZipCode
} from '../helpers/Validation';

import DropdownDate from "react-dropdown-date";
import { formatDate } from '../helpers/Datepicker';
import { stateList, textField } from '../helpers/Form';


class LetterOfAppealForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            gender: null,
            patientDiagnosed: null,
            dob: null,
            patientInCareSince: null
        }
    }

    updateHiddenInput = (name, value, event=null) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    render() {
        const { gender, patientDiagnosed, dob, patientInCareSince} = this.state;
        
        return (
            <div className="row">
                <div className="col-lg-7">
                    <Field
                        name="prescriberName"
                        label="Prescriber name"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <Field
                        name="contactNameOfPharmacy"
                        label="Contact name of pharmacy director or payer"
                        component={textField}
                        validate={isRequiredText}
                        customMobileTop="-30px"
                        customDesktopTop="-10px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-60px"
                        customDesktopLabelTop="-40px"
                    />
                    <Field
                        name="contactTitle"
                        label="Contact title"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <Field
                        name="healthInsuranceCompany"
                        label="Name of health insurance company"
                        component={textField}
                        validate={isRequiredText}
                        customMobileTop="-30px"
                        customDesktopTop="-10px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-60px"
                        customDesktopLabelTop="-40px"
                    />
                    <Field
                        name="address"
                        label="Address"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <Field
                        name="city"
                        label="City"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <div className="form-group">
                        <Field
                            name="state"
                            component="select"
                            validate={isRequiredStateSelection}
                        >                        
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "error" : ""} htmlFor="state">State</label>
                                    <select {...input} className="select-state-css select-css" type="select">
                                        <option name="" value="">- Select state -</option>
                                        {Object.entries(stateList).map(function(state) {
                                            return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                        })}
                                    </select>
                                    {meta.error && meta.touched && meta.error }          
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <Field
                        name="zipCode"
                        label="Zip code"
                        component={textField}
                        validate={isRequiredZipCode}
                        maxLength={5}
                        inputMode="numeric"
                    />
                    <Field
                        name="patientName"
                        label="Patient name"
                        placeholder="Patient name"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <div className="form-group">
                        <Field name="dob" component="input" defaultValue={dob} validate={isRequiredDate}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "error" : ""} htmlFor="dob">Patient&#8217;s date of birth</label> 
                                </Fragment>
                            )}
                        </Field>
                        <DropdownDate
                            onDateChange={date => {
                                this.setState({  dob: formatDate(date) });
                            }}
                            order={                             // optional
                                ['month', 'day', 'year']        // Order of the dropdowns
                            }
                            defaultValues={
                                {
                                    month: "Month", 
                                    day: "Day",
                                    year: "Year"
                                }
                            }
                            options={
                                {
                                    yearReverse: true
                                }
                            }
                            classes={
                                {
                                    month: 'dateDropDownMonthClass',
                                    day: 'dateDropDownDayClass',
                                    year: 'dateDropDownYearClass'
                                }
                            }
                        />
                        <Field name="dob" component="input" defaultValue={dob} validate={isRequiredDate}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="hidden" className={"form-control full-width-input " + (meta.error && meta.touched ? "error" : "") + (meta.valid && meta.touched ? "valid" : "")} />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <div className="form-group">
                        <Field name="gender" component="input" defaultValue={gender} validate={isRequiredSelection}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "error" : ""} htmlFor="gender">Patient gender</label>
                                    <input {...input} type="hidden" className="form-control full-width-input" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                        <button 
                            className={"button blue button-spacing "  + (gender === "female" ? "active" : "")}
                            type="button" 
                            onClick={(e) => this.updateHiddenInput("gender", "female")}
                        >
                            Female
                        </button>
                        <button 
                            className={"button blue button-spacing "  + (gender === "male" ? "active" : "")}
                            type="button"
                            onClick={(e) => this.updateHiddenInput("gender", "male")}
                        >
                            Male
                        </button>
                    </div>
                    <Field
                        name="patientInsuranceGroupName"
                        label="Patient insurance group/policy number"
                        component={textField}
                        validate={isRequiredText}
                        customMobileTop="-10px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-35px"
                        customDesktopLabelTop="-10px"
                        component={textField}
                    />
                    <Field
                        name="policyHoldersName"
                        label="Policyholder's name"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <div className="form-group">
                        <Field className="form-control full-width-input" name="patientDiagnosed" component="input" type="hidden" defaultValue={patientDiagnosed} validate={isRequiredSelection}>
                        {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.touched && meta.error ? "error" : ""} htmlFor="patientDiagnosed">Patient has been diagnosed with Parkinson's disease (PD):</label>
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                        <button 
                            className={"button blue button-spacing "  + (patientDiagnosed  === "yes" ? "active" : "")}
                            type="button" 
                            onClick={(e) => this.updateHiddenInput("patientDiagnosed", "yes")}
                        >
                            True
                        </button>
                        <button 
                            className={"button blue button-spacing "  + (patientDiagnosed === "no" ? "active" : "")}
                            type="button"
                            onClick={(e) => this.updateHiddenInput("patientDiagnosed", "no")}
                        >
                            False
                        </button>
                    </div>
                    <Field
                        name="pdCode"
                        label="PD Code (ICD-10-CM-XX)"
                        placeholder="PD Code (ICD-10-CM-XX)"
                        component={textField}
                        validate={isRequiredText}
                    />
                    <Field
                        name="additionalDiagnosis"
                        label="Describe additional diagnosis of psychosis, hallucinations, and/or delusions (optional)."
                        customMobileTop="-30px"
                        customDesktopTop="-10px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-60px"
                        customDesktopLabelTop="-35px"
                        component={textField}
                    />
                    <Field
                        name="additionalDiagnosisCode"
                        label="Additional diagnosis code (ICD-10-CM-XX)"
                        component={textField}
                        validate={isRequiredText}
                        customMobileTop="-10px"
                        customDesktopTop="10px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-35px"
                        customDesktopLabelTop="-20px"
                        customMarginBottom="90px"
                    />
                    <Field
                        name="conditionAffectsActivity"
                        label="If appropriate, describe how the condition affects activities of daily living or other outcome measures (optional)."
                        customDesktopTop="-10px"
                        customMobileTop="-55px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-80px"
                        customDesktopLabelTop="-40px"
                        customMarginBottom="120px"
                        component={textField}
                    />
                    <Field
                        name="otherTreatmentsForPd"
                        label="If other treatments for PD psychosis were used prior to NUPLAZID<sup>®</sup> (pimavanserin), indicate what was prescribed, as well as the outcome(s) (optional)."
                        customDesktopTop="-10px"
                        customMobileTop="-75px"
                        customMobileMarginTop="80px"
                        customMobileLabelTop="-100px"
                        customDesktopLabelTop="-35px"
                        component={textField}
                    />
                    <div className="relative form-group">
                        <Field name="patientInCareSince" component="input" defaultValue={patientInCareSince} validate={isRequiredDate}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "error" : ""} htmlFor="patientInCareSince">Patient has been in your care since:</label> 
                                </Fragment>
                            )}
                        </Field>
                        <DropdownDate
                            onDateChange={date => {
                                this.setState({  patientInCareSince: formatDate(date) });
                            }}
                            order={
                                ['month', 'day', 'year'] // Order of the dropdowns
                            }
                            defaultValues={
                                {
                                    month: "Month", 
                                    day: "Day",
                                    year: "Year"
                                }
                            }
                            options={
                                {
                                    yearReverse: true
                                }
                            }
                            classes={
                                {
                                    month: 'dateDropDownMonthClass',
                                    day: 'dateDropDownDayClass',
                                    year: 'dateDropDownYearClass'
                                }
                            }
                        />
                        <Field name="patientInCareSince" component="input" defaultValue={patientInCareSince} validate={isRequiredDate}>
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="hidden" className="form-control full-width-input" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        )
    }
}

export default LetterOfAppealForm;